var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredDisappointed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "#FFB02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4472 15.1055C13.9412 15.3525 14.1414 15.9532 13.8944 16.4472C13.1724 17.8913 11.7055 18.6525 10.3041 18.8546C8.91558 19.0549 7.32995 18.7441 6.29289 17.7071C5.90237 17.3166 5.90237 16.6834 6.29289 16.2929C6.68342 15.9023 7.31658 15.9023 7.70711 16.2929C8.17005 16.7558 9.04949 17.0149 10.0185 16.8751C10.9746 16.7372 11.7578 16.2484 12.1056 15.5528C12.3526 15.0588 12.9532 14.8586 13.4472 15.1055Z",
    fill: "#402A32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5528 15.1055C18.0588 15.3525 17.8586 15.9532 18.1056 16.4472C18.8276 17.8913 20.2945 18.6525 21.6959 18.8546C23.0844 19.0549 24.67 18.7441 25.7071 17.7071C26.0976 17.3166 26.0976 16.6834 25.7071 16.2929C25.3166 15.9023 24.6834 15.9023 24.2929 16.2929C23.83 16.7558 22.9505 17.0149 21.9815 16.8751C21.0254 16.7372 20.2422 16.2484 19.8944 15.5528C19.6474 15.0588 19.0468 14.8586 18.5528 15.1055Z",
    fill: "#402A32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7584 24.7258C14.0992 22.3765 17.897 22.3684 20.2455 24.6997C20.6375 25.0888 21.2706 25.0865 21.6597 24.6945C22.0488 24.3026 22.0465 23.6694 21.6546 23.2803C18.5231 20.1717 13.4609 20.1835 10.3417 23.3142C9.95184 23.7054 9.953 24.3386 10.3442 24.7284C10.7355 25.1182 11.3686 25.1171 11.7584 24.7258Z",
    fill: "#402A32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredDisappointed);
export default __webpack_public_path__ + "static/media/coloredDisappointed.cc48427d2b4fc7f906f42b2054abd338.svg";
export { ForwardRef as ReactComponent };